import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Editor, Toolbar, NgxEditorMenuComponent, NgxEditorComponent } from 'ngx-editor';
import { PlanogramApiService } from 'src/app/services/planogram-api.service';
import { PlanogramService } from 'src/app/services/planogram.service';
import { ToastService } from 'src/app/services/toasts.service';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-notes-editor-modal',
    templateUrl: './notes-editor-modal.component.html',
    styleUrl: './notes-editor-modal.component.scss',
    encapsulation: ViewEncapsulation.None,
    imports: [NgxEditorMenuComponent, NgxEditorComponent, FormsModule]
})
export class NotesEditorModalComponent implements OnInit, OnDestroy {
  notes: string = '';
  editor: Editor;

  toolbar: Toolbar = [
    ['bold', 'italic', 'underline'],
    ['ordered_list', 'bullet_list'],
    ['align_left', 'align_center', 'align_right'],
  ];

  constructor(
    private planogramService: PlanogramService,
    private planogramApiService: PlanogramApiService,
    private toastService: ToastService,
    private activeModal: NgbActiveModal
  ){
    this.editor = new Editor();
  }

  ngOnInit(): void {
    let notes = this.planogramService.getSetting('notes');
    this.notes = typeof notes == 'string' ? notes : '';
  }

  ngOnDestroy(): void {
    this.editor.destroy();
  }

  cancel(){
    this.activeModal.dismiss();
  }

  save(){
    this.planogramService.setSetting('notes', this.notes);
    this.planogramApiService.updatePlanogramSettings().subscribe({
      next: (success) => {
        if(success)
        {
          this.toastService.show('Saved planogram notes', {
            classname: `bg-dark text-light p-3 fs-5`,
            delay: 2000,
          });
        }
      }
    });
    this.activeModal.close(this.notes);
  }
}
